module.exports = __webpack_public_path__ + "static/combinadoScreenShot-346537c359d520d3306548c4fa07b5b7.jpg";